import type { ICartadigitalAdminHostToolDeps } from '../tools/tool-types';
import { createCardFormat } from './card-text';
import type { ICardFormat } from './card-text';

/**
 * The card format of the current admin: its UI locale (or `locale`, the
 * language a card was written in), the store's currency and country, and
 * the branch time zone.
 */
export function adminCardFormat(
  deps: Pick<ICartadigitalAdminHostToolDeps, 'i18n' | 'restaurantStore'>,
  timeZone: string,
  locale = deps.i18n.locale
): ICardFormat {
  const restaurant = deps.restaurantStore.restaurant;
  return createCardFormat({
    i18n: deps.i18n,
    locale,
    currency: restaurant?.currency || 'ARS',
    country: restaurant?.country || 'AR',
    timeZone,
  });
}
